module.exports = __webpack_public_path__ + "static/media/pink_line.239b0abf.svg";